import React, { ReactElement } from 'react';
import { Nullable } from '@lerna-core';
import { B2BSubscriptionContentContainer } from '../b2b';
import { B2CSubscriptionContentContainer } from '../b2c';
import { SubscriptionContentModel } from './subscriptionContent.model';
import { SubscriptionContentStyled } from './subscriptionContent.styled';

export const SubscriptionContentContainer = ({
  personalSubscription,
}: SubscriptionContentModel): Nullable<ReactElement> => {
  return (
    <SubscriptionContentStyled>
      {personalSubscription ? (
        <B2CSubscriptionContentContainer />
      ) : (
        <B2BSubscriptionContentContainer />
      )}
    </SubscriptionContentStyled>
  );
};
